

<ul class="category-tree">
  @for(cat of categoriesData?.categories; track $index){
    <ng-container>
      <li>

        <div class="category-item">
          <input
            type="checkbox"
            [(ngModel)]="cat.checked"
            (change)="onCheckboxChange(cat)"
            >

          <span class="label-text">{{ cat.name }}</span>
        </div>

        <!-- Recursive children -->
        @if (cat.children?.length) {
          <app-category-tree
            [categoriesData]="cat.children"
            [selectedIds]="selectedIds">
          </app-category-tree>
        }

      </li>

    </ng-container>
  }
</ul>
